import React from "react";
import {Parallax, Background} from "react-parallax";

class Destination extends React.Component {
    render() {
        return <div id="destination">
            <Parallax
                bgImage="https://www.barcelo.com/guia-turismo/wp-content/uploads/que-visitar-en-barcelona-1.jpg"
                strength={5}>
                <div style={{height: 500}}>
                    <div className="insideStyle">
                        <h1>Destination</h1>
                        <div>Welcome to Barcelona – a city where creativity dances through the streets and every corner bursts with color, flavor, and flair! Imagine Gaudí sketching designs at a beachside tapas bar or Picasso catching a flamenco show. This isn't just a trip – it's a sensory celebration of art, architecture, and passion!
                        </div>
                        <div>In June, Barcelona greets you with sunshine and sea breezes, with average temperatures ranging from 65°F (18°C) to 80°F (27°C).</div>
                        <div>Get ready to soak up the magic! 🎉🌊🎨🍷</div>
                    </div>
                </div>
            </Parallax>
            <div className="content">
                <h2>Hotel</h2>
                <div style={
                    {
                        "display": "flex",
                        "gap": "10px",
                        "justify-content": "space-between",
                    }}
                >

                    <div className="content-inner">
                        <div>
                            <div>ME Hotel, Barcelona</div>
                        </div>

                        <div>WELCOME TO ME BARCELONA! Located in the heart of the city, just steps from Plaça Catalunya and Passeig de Gràcia, ME Barcelona is where contemporary design meets Mediterranean spirit. This stylish, luxury lifestyle hotel blends sleek architecture with curated art, cutting-edge gastronomy, and a vibrant atmosphere. In 2023, it was recognized as one of Europe’s top design-forward hotels, earning accolades for both its service and its rooftop views overlooking the city skyline.</div>
                        <br />
                        <div><a target="_blank"
                                href="https://www.melia.com/en/hotels/spain/barcelona/me-barcelona/">
                                Link To Hotel</a></div>
                        <br/>
                    </div>
                    <img
                        style={{height: '400px', borderRadius: "10px"}}
                        src="https://media-cdn.tripadvisor.com/media/photo-s/21/bb/41/92/rooftop-pool.jpg"
                    />
                </div>

            </div>
        </div>;
    }
}

export default Destination;
